import { MessageCircle, Lightbulb, Heart } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const MethodSection = () => {
  const { t } = useLanguage();

  return (
    <section
      id="metodo"
      className="py-24 md:py-32 bg-white"
      data-testid="method-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs tracking-[0.2em] uppercase text-[#8a9a86] font-medium">
            {t('method.label')}
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-stone-900 tracking-tight leading-tight mt-4 mb-8">
            {t('method.title1')}
            <br />
            <span className="text-[#2c4c3b]">{t('method.title2')}</span>
          </h2>
          <p className="text-stone-600 leading-relaxed text-lg">
            {t('method.subtitle')}
          </p>
        </div>

        {/* Feature Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#e8ece6] rounded-3xl p-10 md:p-14 relative overflow-hidden">
            {/* Decorative element */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#2c4c3b]/5 rounded-full -translate-y-1/2 translate-x-1/2" />
            
            <div className="relative">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 rounded-2xl bg-[#2c4c3b] flex items-center justify-center">
                  <MessageCircle className="w-6 h-6 text-stone-100" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-stone-900">
                  {t('method.interpretation')}
                </h3>
              </div>
              
              <p className="text-stone-600 leading-relaxed text-lg max-w-2xl">
                {t('method.interpretationText')}
                <strong className="text-[#2c4c3b]">{t('method.interpretationHighlight')}</strong>
              </p>

              {/* Additional points */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
                    <Lightbulb className="w-5 h-5 text-[#2c4c3b]" strokeWidth={1.5} />
                  </div>
                  <div>
                    <h4 className="font-medium text-stone-900 mb-1">{t('method.deep')}</h4>
                    <p className="text-stone-600 text-sm leading-relaxed">
                      {t('method.deepText')}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
                    <Heart className="w-5 h-5 text-[#2c4c3b]" strokeWidth={1.5} />
                  </div>
                  <div>
                    <h4 className="font-medium text-stone-900 mb-1">{t('method.holistic')}</h4>
                    <p className="text-stone-600 text-sm leading-relaxed">
                      {t('method.holisticText')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MethodSection;
